import { Box, Flex, Space } from '@mantine/core';
import { useParams } from '@tanstack/react-router';

import { CreateConversationWithAdminButton } from '@/features/chat/modules/CreateConversationWithAdminButton';
import { translate } from '@/shared/i18n/translate';
import { LBBackButton } from '@/shared/modules';
import { LBLinkButton } from '@/shared/ui-kit/components';

import { ArtistInteractionContainer } from '../containers/ArtistinteractionContainer';

export const ArtistInteractionSearchPage = () => {
  const { id: clubId, profileId } = useParams({
    from: '/clubOwner/$id/profile-info/$profileId'
  });

  return (
    <>
      <Box>
        <Flex align='center' justify='space-between'>
          <LBBackButton />
          <CreateConversationWithAdminButton>
            <LBLinkButton>{translate('commons.help')}</LBLinkButton>
          </CreateConversationWithAdminButton>
        </Flex>
        <Space h={16} />
      </Box>
      <ArtistInteractionContainer artistId={profileId} clubId={clubId} />
    </>
  );
};
